import React, { FC } from 'react';

import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { useStores } from '../../../../../hooks';

import styles from './Greeting.module.scss';

const NAME_SPACE = 'recipientPage.greeting';

const Greeting: FC = observer(() => {
    const { t } = useTranslation();

    const {
        recipientPageStore: {
            emailMessageStore: {
                messageId, letterContent,
            },
            sharedFilesStore: {
                senderEmail, allFilesCount,
            },
        },
    } = useStores();

    const hasSender = Boolean(senderEmail);

    const getSubject = (): string => {
        if (letterContent) {
            const anonymousKey = allFilesCount === 1 ? 'subjectAnonymous' : 'subjectAnonymous_plural';
            const namedKey = allFilesCount === 1 ? 'subject' : 'subject_plural';
            const defaultSubject = hasSender
                ? t(`${NAME_SPACE}.${namedKey}`, { sender: senderEmail, count: allFilesCount })
                : t(`${NAME_SPACE}.${anonymousKey}`, { count: allFilesCount });
            return letterContent.subject || defaultSubject;
        }
        if (messageId) {
            return t(`${NAME_SPACE}.subjectEncrypted`);
        }
        if (hasSender) {
            const textString = allFilesCount === 1 ? 'subject' : 'subject_plural';
            return t(`${NAME_SPACE}.${textString}`, { sender: senderEmail, count: allFilesCount });
        }
        const anonymousKey = allFilesCount === 1 ? 'subjectAnonymous' : 'subjectAnonymous_plural';
        return t(`${NAME_SPACE}.${anonymousKey}`, { count: allFilesCount });
    };

    return (
        <div className={styles.container}>
            <h1 className={styles.subject} data-testid="recipientPage_message">
                {getSubject()}
            </h1>
            {hasSender && (
                <span className={styles.from}>
                    {t(`${NAME_SPACE}.from`, { sender: senderEmail })}
                </span>
            )}
        </div>
    );
});

export default Greeting;
